/**
 * Build the `exercises` array for the strength/mobility/yoga workout completion
 * payload. `exerciseTimes` (the live per-exercise counter incremented every
 * second by the timer) is the source of truth for elapsed seconds — we
 * overwrite each exercise's `duration` with `exerciseTimes[idx]`, ignoring
 * whatever stale snapshot may live on `ex.duration`.
 *
 * Why this matters: the timer's `nextExercise` snapshots the live time into
 * `ex.duration` at navigate-away, but `previousExercise` does not. If the user
 * back-navigates, the snapshot on the exercise they left is stale (or 0). At
 * completion we always trust `exerciseTimes[]` instead.
 */
export type StrengthExerciseDataItem = {
  exerciseId: string;
  duration: number;
  completed: boolean;
  sets?: number;
  reps?: number;
};

export function buildStrengthExercisesPayload(
  exerciseData: StrengthExerciseDataItem[] | undefined,
  exerciseTimes: number[],
): StrengthExerciseDataItem[] | undefined {
  return exerciseData?.map((ex, idx) => ({
    ...ex,
    duration: exerciseTimes[idx] ?? 0,
  }));
}
